var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgReload(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 17,
    viewBox: "0 0 16 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.66927 8.4987C2.66927 5.55318 5.05709 3.16536 8.0026 3.16536C9.68064 3.16536 11.1551 3.94103 12.1241 5.16084L11.0046 5.15756C10.6364 5.15648 10.337 5.45408 10.3359 5.82227C10.3349 6.19045 10.6325 6.4898 11.0007 6.49088L13.2959 6.49761C13.3215 6.49917 13.3473 6.49926 13.3731 6.49783L13.6673 6.4987C13.8445 6.49921 14.0145 6.42921 14.14 6.30413C14.2654 6.17905 14.3359 6.00918 14.3359 5.83203L14.3359 3.16536C14.3359 2.79717 14.0375 2.4987 13.6693 2.4987C13.3011 2.4987 13.0026 2.79718 13.0026 3.16536L13.0026 4.13168C11.7942 2.72562 10.0179 1.83203 8.0026 1.83203C4.32071 1.83203 1.33594 4.8168 1.33594 8.4987C1.33594 12.1806 4.32071 15.1654 8.0026 15.1654C10.6266 15.1654 12.8454 13.6505 13.9329 11.4621C14.0968 11.1323 13.9623 10.7322 13.6326 10.5684C13.3029 10.4045 12.9028 10.539 12.7389 10.8687C11.8629 12.6314 10.0903 13.832 8.0026 13.832C5.05709 13.832 2.66927 11.4442 2.66927 8.4987Z",
    fill: "#272B30"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgReload);
export default __webpack_public_path__ + "static/media/reload.8784cb2d22e27eb1569edc9d47cfd55e.svg";
export { ForwardRef as ReactComponent };